module.exports = __webpack_public_path__ + "img/bell-active.ca94320.svg";